<div class="righticons-bar">
  <img src="{{ cdnEndPoint }}/shared/images/SVG/feedback_red.png" class="bot-chat" alt="Feedback" (click)="openFeedbackWindow()" />
</div>

<div class="feedback-panel" *ngIf="isFeedbackOpen">
  <div class="feedback-header">
    <span>Tell us about your experience</span>
    <button class="close-btn" (click)="closeFeedbackWindow()">&times;</button>
  </div>

  <div class="feedback-body" *ngIf="!isSubmitted">
    <form [formGroup]="feedbackForm" (ngSubmit)="submitFeedback()">
      <h3 class="feedback-question">What is your feedback category?</h3>
      <div class="feedback-categories">
        <button type="button" *ngFor="let cat of categories" class="category-btn"
          [class.selected]="selectedCategory === cat"
          (click)="selectCategory(cat)">
          {{ cat }}
        </button>
      </div>

      <div class="form-group">
        <label for="feedbackComment"><b>Please provide your feedback:</b></label>
        <textarea id="feedbackComment" formControlName="comment" class="feedback-textarea"
          rows="5" placeholder="" maxlength="250"></textarea>
        <div class="char-count" *ngIf="feedbackForm.get('comment')?.value">
          {{ feedbackForm.get('comment')?.value?.length }} / 250
        </div>
      </div>

      <button type="submit" class="submit-btn" [disabled]="!selectedCategory || feedbackForm.invalid || isSubmitting">
        <span *ngIf="!isSubmitting">Submit Feedback</span>
        <span *ngIf="isSubmitting">Submitting...</span>
      </button>
    </form>
  </div>

  <div class="feedback-body thankyou" *ngIf="isSubmitted">
    <h3>Thank you for helping us improve your experience!</h3>
  </div>
</div>
